import {
    getCommentDetails,
    getPostComments,
    reactToComment,
    unReactToComment,
} from "@infrastructure/Services/PostCommentsService";
import { PostCommentsInfo } from "@infrastructure/Services/PostCommentsService.types";
import { ReactionResponse } from "../Shared/Types/Reactions/ReactionTypes.types";
import { mapToEntityReactions } from "@infrastructure/Persistence/Reactions";
import { RequestCriteriaType } from "@infrastructure/Services/PostService.types";

export const fetcherGetPostComments = function <
    CommentType,
    CommentIdType = number,
>(postId: string, sortCriteria: RequestCriteriaType) {
    return getPostComments<CommentIdType>(postId, sortCriteria).then((res) => {
        return res.map((item) =>
            mapServerResponseToComment<CommentType, CommentIdType>(item),
        );
    });
};

export const mapServerResponseToComment = <
    CommentType,
    ResponseCommentIdType = number,
>(
    response: PostCommentsInfo<ResponseCommentIdType>,
): CommentType => {
    const commentReactions = mapToEntityReactions(response.reactionCount);
    return {
        postId: response.postId,
        id: response.id,
        commentContent: {
            id: response.id,
            images: response.images.map((item) => ({
                id: item.id,
                url: item.url,
            })),
            text: response.content,
            linkoutUrl: response.linkoutUrl,
            date: response.createdAt,
            updatedAt: response.updatedAt,
            user: response.createdBy,
            showAvatar: true,
            isEdited: response.isEdited,
            isDeleted: response.isDeleted,
            isSuspended: response.isSuspended,
            isOwnComment: response.isOwn,
            isEditorial: response.isEditorial,
            isHighlighted: response.isHighlighted,
        },
        commentReply: response.referencedComment && {
            id: response.referencedComment.id,
            text: response.referencedComment.content,
            user: response.referencedComment.createdBy,
            images: response.referencedComment.images,
            isDeleted: response.referencedComment.isDeleted,
            isSuspended: response.referencedComment.isSuspended,
        },
        commentReactions: commentReactions,
        cursor: response.cursor,
    } as CommentType;
};

export function fetcherReactToComment(
    commentId: string,
    reactionTypeName: string,
): Promise<ReactionResponse> {
    return reactToComment(commentId, reactionTypeName).then((response) => ({
        reactions: mapToEntityReactions(
            response.commentReactions.reactionCount,
        ),
    }));
}

export function fetcherUnReactToComment(
    commentId: string,
    reactionTypeName: string,
): Promise<ReactionResponse> {
    return unReactToComment(commentId, reactionTypeName).then((response) => ({
        reactions: mapToEntityReactions(
            response.commentReactions.reactionCount,
        ),
    }));
}

export function fetcherCommentDetails(id: string): Promise<PostCommentsInfo> {
    return getCommentDetails(id);
}
